import { PaymentResponseType } from "@app/shared/models/userBalance";
import { environment } from "@env";

export const PRODUCT_NAME = 'ePRINTit';

export const SUCCESS_URL = environment.redirectBaseUrl + PaymentResponseType.success;
export const Error_URL = environment.redirectBaseUrl + PaymentResponseType.error;

export const BRAINTREE_BASE_URL = environment.apiBaseUrl + 'braintree/transaction';
export const AUTHORIZE_NET_BASE_URL = environment.authorizeNetURL;
export const WEBHOOK_HEARTLAND_URL = environment.apiBaseUrl + 'heartland/response';

export const AUTHORIZE_NET_WEB_URL = 'https://www.authorize.net/';
export const HEART_LAND_WEB_URL = 'https://www.heartland.us/';
export const BLANK_URL = 'https://mobile.eprintitsaas.org/blank';
// Set socket timeout (5 min)
export const SOCKET_TIMEOUT = 300000;

export const LIBRARY_SOCKET_TIMEOUT = 60000;
